//配置axios

import axios from 'axios';
import { Toast } from 'vant';
import store from '../vuex/store.js';
import base from './base.js';
import { jumpToMini } from '../utils/index.js';

let tokenAbnormal = true;

// 请求超时时间
axios.defaults.timeout = 1000 * 10;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

// 设置公共url
axios.defaults.baseURL = base.baseUrl; //'http://192.168.1.204:9805'
// function checkToken(token) {
//   let Base64 = require("js-base64").Base64;
//   let tk = token; //"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb21wYW55SWQiOiIwMjAxYjRhYjUzMGI5ZmZlMmZlNzIxNTJmZTRhYjE5NSIsInN0YWZmTmFtZSI6Ium7hOiKsyIsInN0YWZmSWQiOiJkZjAwYjlhYjZlYmMzYWIwMTc1M2Y4ZTAwYTRiOTQwOSIsImlhdCI6MTY3MzUxNTA4MSwiZXhwIjoxNjczNTIyMjgxLCJuYmYiOjE2NzM1MTUwODF9.owYBDjvlielj1Ma_QakPlErPHky248RcFLJFrFdfWR8";
//   let tangdaye = JSON.parse(Base64.decode(tk.split(".")[1]));
//   let endTime = new Date(tangdaye.exp * 1000);
//   let oldDate = store.state.stateObject.tokenRefreshTime;
//   if (endTime - new Date() < 3600000 && endTime > new Date()) {
//     commonObj.checkTokenRefresh();
//   } else if (endTime < new Date()) {
//     commonObj.logout("登陆已失效");
//   }
//   //3600000-86400000
//   if (new Date() - oldDate > 3600000 && new Date() - oldDate < 86400000) {
//     commonObj.checkTokenRefresh();
//   } else if (new Date() - oldDate > 86400000) {
//     commonObj.logout("登陆已失效");
//   }
//   // console.log(tangdaye)
// }

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    config.headers['Accept'] = 'application/json;charset=UTF-8';
    //注入token
    config.headers['token'] = store.state.token ? store.state.token : '';
    config.headers['hisId'] = store.state.project ? store.state.project.hisId : '';
    config.headers['port'] = 6;
    return config;
  },
  function(error) {
    console.log(error);
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    if (response.status == 200) {
      const { data } = response;
      // let params = `?hisId=${store.state.project.hisId}&resourceType=${store.state.project.resourceType}`;
      if (data.code == '010010') {
        console.log(data);
        //未登录
        store.commit('removeUserInfo');
        store.commit('removeToken');
        if (tokenAbnormal) {
          tokenAbnormal = false;
          jumpToMini('navigateTo', `/pages/login/page/index`);

          setTimeout(() => {
            tokenAbnormal = true;
          }, 3000);
        }
      } else if (data.code == '020002') {
        //登录失效
        console.log(data);
        store.commit('removeUserInfo');
        store.commit('removeToken');
        if (tokenAbnormal) {
          tokenAbnormal = false;
          jumpToMini('navigateTo', `/pages/login/page/index`);

          setTimeout(() => {
            tokenAbnormal = true;
          }, 3000);
        }
      }
      return response.data;
    } else {
      Toast(response.data.msg);
      return response.data;
    }
  },
  function(error) {
    console.log(error.message);
    var title = '';
    if (error.message.includes('timeout')) {
      // 判断请求异常信息中是否含有超时timeout字符串
      Toast('网络超时'); // reject这个错误信息
      title = '网络超时';
    } else {
      if (error.code == 'ECONNABORTED' || error.message.indexOf('Network Error') > -1) {
        Toast('网络异常！');
        title = '网络异常！';
      } else {
        Toast('服务异常！');
        title = '服务异常！';
      }
    }
    // if(error.message!="Cannot read properties of undefined (reading 'cancelToken')"){
    //   commonLogan.loganLog(title+error.message+ "postParm:"+JSON.stringify(error.config),1);
    // }
    //commonLogan.loganLog(title+error.message+ "postParm:"+JSON.stringify(error.config),1);

    try {
      SXApi.call(function(suc) {}, null, 'FunctionPlugin', 'postError', {
        message: error.message + '|||(' + title + ')|||(' + error.code + ')'
      });
    } catch (error) {}
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/request/$http.js